import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IPackageFolderTagMismatch } from "../../models/transfer-package-response";
import { BreadcrumbDataService } from "../../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { IBreadcrumbItem } from "../../../../main/layout/tool-bar/model/breadcrumb.model";
import { tap } from "rxjs";
import { ComponentConstants } from "../../constants/component-constants";
import { MatButton } from "@angular/material/button";
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";

@Component({
    selector: "app-tag-mismatch-table-dialog",
    templateUrl: "./tag-mismatch-table-dialog.component.html",
    styleUrls: ["./tag-mismatch-table-dialog.component.scss"],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class TagMismatchTableDialogComponent implements OnInit {
  private readonly breadcrumbDataService = inject(BreadcrumbDataService);
  dialogRef = inject<MatDialogRef<TagMismatchTableDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public dataSource: IPackageFolderTagMismatch[] = [];
  public currentBreadcrumbItem: IBreadcrumbItem = null;
  public sourceBucket: string;
  public destinationBucket: string;
  displayedColumns: string[];
  private readonly featureToken = 'bucket-items';
  private readonly surfaceToken = 'tag-mismatch-dialog';

  constructor() {
    this.breadcrumbDataService.selectedBreadcrumb$
      .pipe(
        tap((item: IBreadcrumbItem) => {
          this.currentBreadcrumbItem = item;
          if (this.currentBreadcrumbItem.BucketType === "StudyDataCollection") {
            this.sourceBucket = ComponentConstants.STUDYDATACOLLECTION;
            this.destinationBucket = ComponentConstants.PREARCHIVE;
          } else if (
            this.currentBreadcrumbItem.BucketType === "FacilityDataCollection"
          ) {
            this.sourceBucket = ComponentConstants.FACILITYDATACOLLECTION;
            this.destinationBucket = ComponentConstants.PREARCHIVE;
          } else if (this.currentBreadcrumbItem.BucketType === "PreArchive") {
            this.sourceBucket = ComponentConstants.PREARCHIVE;
            this.destinationBucket = ComponentConstants.FACILITYARCHIVE;
          }
          this.displayedColumns = [
            "Package folder",
            this.sourceBucket,
            this.destinationBucket
          ];
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.dataSource = [...this.data];
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  public buildControlId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join('-');
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return this.slugify(value);
    }
    return '00';
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }
}
